import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "src/shadcn/ui/tooltip";

export const formatPercentage = (value?: number, decimals = 0): string => {
  const numericValue = typeof value === "number" && Number.isFinite(value) ? value : 0;
  return `${Math.max(0, numericValue).toFixed(decimals)}%`;
};

interface MetricLineProps {
  label: string;
  tooltip: string;
  percentage?: number;
  decimals?: number;
  isLoading?: boolean;
}

export const MetricLine: React.FC<MetricLineProps> = ({ label, tooltip, percentage, decimals, isLoading }) => {
  if (isLoading) {
    return <div className="h-5 w-48 animate-pulse rounded bg-secondary-100" />;
  }

  return (
    <div className="flex items-center justify-between gap-2 text-sm font-medium text-secondary-600 w-[200px]">
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help">{label}</span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs leading-relaxed">{tooltip}</TooltipContent>
      </Tooltip>
      <span className="ml-auto font-semibold text-secondary-900">{formatPercentage(percentage, decimals)}</span>
    </div>
  );
};
